<app-dialog
  #dialog
  [key]="'modal-bank-managers'"
  [action]="'bank-managers'"
  [headerTheme]="'simple'"
  [title]="'Gerentes Bancários - ' + financialInstitutionName"
  [maxWidth]="'1200px'"
  [showMaximizeButton]="true"
  (onClose)="close()">
  <div class="modal-bank-managers">
    <div class="modal-bank-managers__header">
      <app-button
        [id]="'add-bank-manager'"
        [label]="'Adicionar Gerente'"
        [icon]="'pi pi-plus'"
        [type]="'button'"
        (sendButtonClick)="openAddDialog()"></app-button>
    </div>

    <app-table
      [hasFilter]="false"
      [reorderableColumns]="false"
      [title]="'Gerentes'"
      [subtitle]="''"
      [resizableColumns]="false"
      [sortable]="true"
      [hasPagination]="true"
      [totalRecords]="totalRecords"
      [items]="bankManagers"
      [showSearch]="true"
      [columnDefinitions]="columnDefinitions"
      [rows]="pagination.pageSize || 10"
      [getOptionsFunction]="getMenuActions.bind(this)"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableFilter)="handleSearch($event)">
      <ng-template appNamedTemplate="phone" let-item>
        {{ item.phone | vaultMaskPhone }}
      </ng-template>
      <ng-template appNamedTemplate="position" let-item>
        <span *ngIf="item.position; else noPosition">
          {{ item.position | vaulttranslateEnum: 'BankManagerPosition' }}
        </span>
        <ng-template #noPosition>-</ng-template>
      </ng-template>
      <ng-template appNamedTemplate="notes" let-item>
        @if (notesTooltip(item.notes); as notesText) {
          <span
            class="notes-cell"
            role="note"
            tabindex="0"
            [attr.aria-label]="notesAriaLabel(item.notes)"
            [pTooltip]="notesText"
            tooltipEvent="both"
            tooltipPosition="top"
            tooltipStyleClass="long-text-tooltip"
            >{{ item.notes }}</span
          >
        } @else {
          -
        }
      </ng-template>
    </app-table>
  </div>
</app-dialog>

<!-- Modal de Cadastro/Edição -->
<app-dialog
  #addEditDialog
  [key]="'modal-add-edit-bank-manager'"
  [action]="'add-edit-bank-manager'"
  [headerTheme]="'simple'"
  [title]="isEditMode ? 'Editar Gerente Bancário' : 'Cadastrar Gerente Bancário'"
  [maxWidth]="'600px'"
  [hideDefaultFooter]="true"
  (onClose)="closeAddEditDialog()">
  <form [formGroup]="bankManagerForm" appAutoFormGroup class="bank-manager-form">
    <div class="form-fields">
      <!-- Email (obrigatório) -->
      <app-input
        [type]="'email'"
        [placeholder]="'email@exemplo.com'"
        [controlName]="'email'"
        [label]="'Email'"
        [tooltipText]="'Informe o email de contato do gerente'"
        [required]="true"></app-input>
      <div
        *ngIf="
          bankManagerForm.get('email')?.hasError('emailExists') &&
          bankManagerForm.get('email')?.touched
        "
        class="error-message">
        Email já existente
      </div>
      <div *ngIf="isCheckingEmail" class="checking-email">Verificando email...</div>

      <!-- Nome (obrigatório) -->
      <app-input
        [type]="'text'"
        [placeholder]="'Nome completo'"
        [controlName]="'name'"
        [label]="'Nome'"
        [tooltipText]="'Informe o nome completo do gerente bancário'"
        [required]="true"></app-input>

      <!-- Cargo (obrigatório) -->
      <app-select
        [options]="positionOptions"
        [selectedOption]="selectedPosition"
        [controlName]="'position'"
        [label]="'Cargo'"
        [placeholder]="'Selecione o cargo'"
        [tooltipText]="'Cargo ou posição do gerente na instituição'"
        (sendSelectedOption)="onPositionChange($event)"></app-select>

      <!-- Telefone fixo (opcional) -->
      <app-input
        [type]="'useMask'"
        [unmask]="true"
        mask="(99) 9999-9999"
        [placeholder]="'(00) 0000-0000'"
        [controlName]="'landlinePhone'"
        [label]="'Telefone fixo'"
        [tooltipText]="'Telefone fixo da mesa/banco, com DDD e 8 dígitos (opcional)'"
        [required]="false"></app-input>

      <!-- Celular (opcional) -->
      <app-input
        [type]="'useMask'"
        [unmask]="true"
        mask="(99) 99999-9999"
        [placeholder]="'(00) 00000-0000'"
        [controlName]="'phone'"
        [label]="'Celular'"
        [tooltipText]="'Celular do contato, com DDD e 9 dígitos (opcional)'"
        [required]="false"></app-input>

      <!-- Região (opcional) -->
      <app-input
        [type]="'text'"
        [placeholder]="'Região/Localidade'"
        [controlName]="'location'"
        [label]="'Região'"
        [tooltipText]="'Região ou localidade do gerente (opcional)'"
        [required]="false"></app-input>

      <!--
        Cadastro do gerente por instituição: não há empresa no contexto, então só existe a observação
        global. O aviso de que ela é compartilhada (e o bloqueio para quem não é do time interno) vem
        do componente compartilhado.
      -->
      <app-contact-notes-fields [form]="bankManagerForm" [showCompanyNotes]="false" />
    </div>
  </form>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [type]="'button'"
        [theme]="'white'"
        (sendButtonClick)="closeAddEditDialog()"></app-button>

      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isSubmitting"
        [loadingText]="isEditMode ? 'Atualizando...' : 'Salvando...'"
        [label]="isEditMode ? 'Atualizar' : 'Salvar'"
        [type]="'button'"
        (sendButtonClick)="submitBankManager()"></app-button>
    </div>
  </ng-template>
</app-dialog>
